import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/images/loading_new.png'


const _hoisted_1 = { class: "reason-con" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "reason-tips" }, [
  /*#__PURE__*/_createElementVNode("p", null, "希望您告知原因，帮助我们改进，谢谢！")
], -1)
const _hoisted_3 = { class: "reason-items" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "new-loading"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "new-loading-con" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("p", null, "解析加载中…")
], -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasons, (reason) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["item", { 'select_cur': reason.reason_id === _ctx.reasonId}]),
          onClick: ($event: any) => (_ctx.chooseReason(reason.reason_id)),
          key: reason.reason_id
        }, [
          _createTextVNode(_toDisplayString(reason.reason_title) + " ", 1),
          _hoisted_5
        ], 10, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["next-step-btn", { 'cur': _ctx.reasonId !== 0}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteAccountFn()))
    }, "下一步", 2),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}